export default "__VITE_ASSET__KIArEEal__"